export default {"src":"/_next/static/media/preferred_vendor_badge.6a47980e.svg","height":197,"width":216,"blurWidth":0,"blurHeight":0};